<template>
	<div class="payment-channels-wrapper">
		<draggable
			class="w-100 d-block"
			group="channels"
			v-model="paymentChannels"
			v-bind="dragOptions"
			@start="drag = true"
			@end="drag = false"
			@change="onChange">
			<transition-group
				class="d-block w-100"
				type="transition"
				:name="!drag ? 'flip-list' : null">
				<div
					class="px-3 py-2 list-group-item list-group-item-action d-flex align-items-center"
					v-for="paymentChannel in paymentChannels"
					:key="paymentChannel.key">
					<button
						class="btn btn-sm btn-plain drag-item mr-2 p-0"
						v-tooltip="'Drag to reorder'">
						<i class="material-icons">drag_indicator</i>
					</button>
					<label class="cur-p mb-0">
						<input
							type="checkbox"
							class="input-checkbox input-checkbox-large"
							:value="paymentChannel.key"
							:disabled="paymentChannel.disabled"
							v-model="selectedPaymentChannels"
							@change="onChange"
						>
						<span></span>
						<img
							class="payment-channel-icon ml-2"
							:src="`https://cdn.orderonline.id/icons/payment-channel-${paymentChannel.key}.png`"
							alt="Icon">
						<span
							class="input-checkbox-text"
							v-tooltip="paymentChannel.disabled ? 'Coming Soon!' : ''">
							<!-- <span></span> -->
							{{ paymentChannel.label }}
						</span>
					</label>
					<div class="ml-auto flex-center">
						<i
							class="material-icons info"
							v-tooltip="paymentChannel.info"
							v-if="paymentChannel.info">info</i>
						<i
							class="material-icons text-secondary ml-2"
							v-tooltip="'Config'"
							@click="editDescription(paymentChannel)"
							v-if="hasConfig">settings</i>
					</div>
				</div>
			</transition-group>
		</draggable>
		<div class="modals">
			<!-- Channel Description -->
			<modal
				class="section-titles-modal"
				size="medium"
				@close="isDescriptionVisible = false"
				v-if="isDescriptionVisible && selected">
				<template slot="header">
					<h3>Channel - {{ selected.label }}</h3>
				</template>
				<template slot="body">
					<div class="form-group mb-0">
						<label>Description:</label>
						<textarea
							class="form-control"
							placeholder="Description"
							:value="descriptions[selected.key]"
							@input="onDescriptionChange">
						</textarea>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import Modal from '@/components/Modal.vue';
import { paymentChannels } from '@/lib/statics';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'PaymentChannels',
	components: {
		draggable,
		Modal,
	},
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		descriptions: {
			type: Object,
			default: () => {},
		},
		hasConfig: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			paymentChannels: duplicateVar(paymentChannels),
			selectedPaymentChannels: [],
			drag: false,
			dragOptions: {
				animation: 100,
			},
			selected: null,
			isDescriptionVisible: true,
		};
	},
	methods: {
		init() {
			const selectedChannels = duplicateVar(this.value);
			const channelOptions = selectedChannels.map(channel => this.paymentChannels.find(({ key }) => key === channel));
			for (let index = 0; index < this.paymentChannels.length; index++) {
				const paymentChannel = this.paymentChannels[index];
				const isNotExist = channelOptions.findIndex(({ key }) => key === paymentChannel.key) === -1;
				if (isNotExist) {
					channelOptions.push(paymentChannel);
				}
			}
			this.paymentChannels = channelOptions;
			this.selectedPaymentChannels = selectedChannels;
		},
		onChange() {
			const options = this.paymentChannels;
			const channels = duplicateVar(this.selectedPaymentChannels);
			const selected = options
				.filter(({ key }) => channels.includes(key))
				.map(({ key }) => key);
			this.$emit('input', selected);
		},
		editDescription(channel) {
			this.selected = channel;
			this.isDescriptionVisible = true;
		},
		onDescriptionChange(e) {
			const value = e.target.value;
			if (this.selected) {
				const key = this.selected.key;
				this.descriptions[key] = value;
				this.$emit('update:descriptions', this.descriptions);
			}
		},
	},
	created() {
		this.init();
	},
};
</script>
